import * as React from 'react';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper';
import EfImg from '@elem/ui/ef-img';
import styled from './index.module.scss';
import { useLang } from '@/i18n';
import 'swiper/scss';

interface IBrandsProps {
    name: string;
    img: string;
}

const keyframesLeft = `
@keyframes scroll-left {
    0% { transform: translateX(0); }
    100% { transform: translateX(calc(-100% - var(--brands-gap, 0px))); }
}
`;
const keyframesRight = `
    @keyframes scroll-right {
    0% { transform: translateX(calc(-100% - var(--brands-gap, 0px))); }
    100% { transform: translateX(0); }
}
`;

const ListA1 = () => {
    const { t } = useLang('theProduct.ListA1');
    const [gap, setGap] = React.useState(24); // 间距，大于1440px时为24，大于1024px时为16，小于1024px时为10，单位px，默认24px

    const brands: IBrandsProps[] = [
        {
            name: 'tibber',
            img: 'https://websiteoss.ecoflow.com/upload/image/1742989685208/tibber.png',
        },
        {
            name: 'google',
            img: 'https://websiteoss.ecoflow.com/upload/image/1743162336812/google.png',
        },
        {
            name: 'ecobee',
            img: 'https://websiteoss.ecoflow.com/upload/image/1743162333722/ecobee.png',
        },
        {
            name: 'shelly',
            img: 'https://websiteoss.ecoflow.com/upload/image/1742989689031/shelly.png',
        },
        {
            name: 'tado',
            img: 'https://websiteoss.ecoflow.com/upload/image/1743162357936/tado.png',
        },
        {
            name: 'tapo',
            img: 'https://websiteoss.ecoflow.com/upload/image/1742989693568/tapo.png',
        },
        {
            name: 'everyhome',
            img: 'https://websiteoss.ecoflow.com/upload/image/1742989697349/everhome.png',
        },
        {
            name: 'kasa',
            img: 'https://websiteoss.ecoflow.com/upload/image/1742989700288/kasa.png',
        },
    ];

    const brands2: IBrandsProps[] = [
        {
            name: 'nord pool',
            img: 'https://websiteoss.ecoflow.com/upload/image/1743162681913/nordpool.png',
        },
        {
            name: 'epexspot',
            img: 'https://websiteoss.ecoflow.com/upload/image/1743162679449/epexspot.png',
        },
        {
            name: 'octopus',
            img: 'https://websiteoss.ecoflow.com/upload/image/1743162684128/octopus.png',
        },
        {
            name: 'robot',
            img: 'https://websiteoss.ecoflow.com/upload/image/1743162687393/rabot.png',
        },
    ];

    // React.useEffect(() => {
    //     if (typeof window !== 'undefined') {
    //         const winW = window?.innerWidth;
    //         setGap(winW > 1440 ? 48 : winW > 1024 ? 36 : 20);
    //     }
    // }, []);

    React.useEffect(() => {
        const style = document.createElement('style');
        document.head.appendChild(style);
        style.sheet?.insertRule(keyframesLeft, 0);
        style.sheet?.insertRule(keyframesRight, 0);
        return () => {
            style.remove();
        };
    }, []);

    return (
        <div className={styled.ListA1}>
            <EcoSpace />
            <EcoSectionCommon title={t('title')} desc={t('desc')} />
            <div className="brands-container">
                <div className="brands-ani">
                    <div className="brands">
                        {[...brands].map((item, idx) => (
                            <div className="brand-item" key={idx}>
                                <img src={item.img} />
                            </div>
                        ))}
                    </div>
                    {/* 复制一层用于循环 */}
                    {Array.from({ length: 2 }).map((i, idx1) => (
                        <div className="brands" key={idx1}>
                            {[...brands].map((item, idx2) => (
                                <div className="brand-item" key={`${idx1}-${idx2}`}>
                                    <img src={item.img} />
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
            <div className="brands-container reverse">
                <div className="brands-ani">
                    <div className="brands">
                        {[...brands2].map((item, idx) => (
                            <div className="brand-item" key={idx}>
                                <img src={item.img} />
                            </div>
                        ))}
                    </div>
                    {Array.from({ length: 2 }).map((i, idx1) => (
                        <div className="brands" key={idx1}>
                            {[...brands2].map((item, idx2) => (
                                <div className="brand-item" key={`${idx1}-${idx2}`}>
                                    <img src={item.img} />
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ListA1;
